import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Abouthouston() {
  return (
    <section className="about_houston tekrevol_dark_bg max_miami p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol for App Development in Washington DC?</h2>
            <p>
              Experience innovation at its best with TekRevol. Our team in
              Washington DC offers unparalleled expertise in app development,
              providing tailor-made solutions to suit your business needs. We
              excel in crafting apps that stand out, offering cutting-edge
              technology and personalized service. Trust TekRevol to elevate
              your digital presence and redefine user experiences in the
              nation's capital. With a track record of successful projects and a
              commitment to excellence, TekRevol is the ideal partner for your
              app development journey in Washington DC.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="mt-lg-auto mt-md-0"
          >
            <div className="maximize_miami_img">
              <StaticImage
                src="../../images/location_new/washington/why_choose_washington.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={907}
                height={841}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Abouthouston;
